import { HelpCircle } from 'lucide-react'
import { Label } from '@/components/ui/label'
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip'

interface LabelWithTooltipProps {
    label: string
    tooltip: string
}

export const LabelWithTooltip = ({ label, tooltip }: LabelWithTooltipProps) => (
    <div className="flex items-center gap-1">
        <Label className="text-sm">{label}</Label>
        <Tooltip>
            <TooltipTrigger asChild>
                <HelpCircle className="size-3 cursor-help text-gray-400 hover:text-gray-600" />
            </TooltipTrigger>
            <TooltipContent>
                <p className="max-w-xs text-xs">{tooltip}</p>
            </TooltipContent>
        </Tooltip>
    </div>
)

